import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { ActiveSurveyDetailsPage } from "./pages/active-survey-details/ActiveSurveyDetailsPage";
import { CreateAutomatedSurveyPage } from "./pages/create-or-edit/CreateAutomatedSurveyPage";
import { EditAutomatedSurveyPage } from "./pages/create-or-edit/EditAutomatedSurveyPage";
import { ListAutomatedSurveysPage } from "./pages/list/ListAutomatedSurveysPage";
import { canListAutomatedSurveys, canManageAutomatedSurveys } from "./permissions";
import { automatedSurveysRoutes } from "./routes";

export const automatedSurveysRoute = [
  {
    path: automatedSurveysRoutes.list,
    element: (
      <RequireAuth permission={canListAutomatedSurveys}>
        <ListAutomatedSurveysPage />
      </RequireAuth>
    ),
  },
  {
    path: automatedSurveysRoutes.create,
    element: (
      <RequireAuth permission={canManageAutomatedSurveys}>
        <CreateAutomatedSurveyPage />
      </RequireAuth>
    ),
  },
  {
    path: automatedSurveysRoutes.edit,
    element: (
      <RequireAuth permission={canManageAutomatedSurveys}>
        <EditAutomatedSurveyPage />
      </RequireAuth>
    ),
  },
  {
    path: automatedSurveysRoutes.details,
    element: (
      <RequireAuth permission={canListAutomatedSurveys}>
        <ActiveSurveyDetailsPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
